namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoHdActRow {
        Id?: number;
        PromoCampaign?: string;
        PromoCampName?: string;
        PmGroupId?: string;
        PmGroupDesc?: string;
        StartPromoDate?: string;
        EndPromoDate?: string;
        PromoTimeFg?: PromoTimeFg;
        StartPromoTime?: string;
        EndPromoTime?: string;
        PromoDayFg?: PromoDayChFg;
        PromoDay?: number[];
        PromoShopFg?: PromoShopFg;
        PromoShop?: string[];
        PromoCustFg?: number;
        PromoMb?: string[];
        PromoApproveFg?: number;
        PromoStatus?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
        ApproveBy?: string;
        Approvedate?: string;
        ActiveBy?: string;
        Activedate?: string;
        ItemList?: PsAdvPromoItemRow[];
        ItemExList?: PsAdvPromoItemExemptRow[];
        Item2List?: PsAdvPromoItem2Row[];
        Item2ExList?: PsAdvPromoItem2ExemptRow[];
        Item3List?: PsAdvPromoItem3Row[];
        Item3ExList?: PsAdvPromoItem3ExemptRow[];
        Item4List?: PsAdvPromoItem4Row[];
        Item4ExList?: PsAdvPromoItem4ExemptRow[];
        Item5List?: PsAdvPromoItem5Row[];
        Item5ExList?: PsAdvPromoItem5ExemptRow[];
        Item6List?: PsAdvPromoItem6Row[];
        Item6ExList?: PsAdvPromoItem6ExemptRow[];
        Item9List?: PsAdvPromoItem9Row[];
        Item9ExList?: PsAdvPromoItem9ExemptRow[];
        VenderSharing?: number;
    }

    export namespace PsAdvPromoHdActRow {
        export const idProperty = 'PmGroupId';
        export const nameProperty = 'PmGroupId';
        export const localTextPrefix = 'AdvPromo.PsAdvPromoHdAct';
        export const lookupKey = 'AdvPromo.PsAdvPromoHdAct';

        export function getLookup(): Q.Lookup<PsAdvPromoHdActRow> {
            return Q.getLookup<PsAdvPromoHdActRow>('AdvPromo.PsAdvPromoHdAct');
        }
        export const deletePermission = '4ADVANCED_PROMOTION:Active:Modify';
        export const insertPermission = '4ADVANCED_PROMOTION:Active:Modify';
        export const readPermission = '4ADVANCED_PROMOTION:Active:View';
        export const updatePermission = '4ADVANCED_PROMOTION:Active:Modify';

        export declare const enum Fields {
            Id = "Id",
            PromoCampaign = "PromoCampaign",
            PromoCampName = "PromoCampName",
            PmGroupId = "PmGroupId",
            PmGroupDesc = "PmGroupDesc",
            StartPromoDate = "StartPromoDate",
            EndPromoDate = "EndPromoDate",
            PromoTimeFg = "PromoTimeFg",
            StartPromoTime = "StartPromoTime",
            EndPromoTime = "EndPromoTime",
            PromoDayFg = "PromoDayFg",
            PromoDay = "PromoDay",
            PromoShopFg = "PromoShopFg",
            PromoShop = "PromoShop",
            PromoCustFg = "PromoCustFg",
            PromoMb = "PromoMb",
            PromoApproveFg = "PromoApproveFg",
            PromoStatus = "PromoStatus",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate",
            ApproveBy = "ApproveBy",
            Approvedate = "Approvedate",
            ActiveBy = "ActiveBy",
            Activedate = "Activedate",
            ItemList = "ItemList",
            ItemExList = "ItemExList",
            Item2List = "Item2List",
            Item2ExList = "Item2ExList",
            Item3List = "Item3List",
            Item3ExList = "Item3ExList",
            Item4List = "Item4List",
            Item4ExList = "Item4ExList",
            Item5List = "Item5List",
            Item5ExList = "Item5ExList",
            Item6List = "Item6List",
            Item6ExList = "Item6ExList",
            Item9List = "Item9List",
            Item9ExList = "Item9ExList",
            VenderSharing = "VenderSharing"
        }
    }
}
